/**
 *
 * @param s {string}
 * @returns {string}
 */
export function persianArabicToEnglish(s: string): string {
    if (!s) {
        return "";
    }
    return s
      .toString()
      .replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
      .replace(/[٠-٩]/g, d => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
};

export function stringConvert() {
    return (String.prototype.toPersianDigits = function() {
        let id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        return this.replace(/[0-9]/g, function(w) {
            return id[+w];
        });
    });
};

export const calculateDay = create_at => {
    if (create_at === 0) {
      return 'امروز';
    } else if (create_at < 7) {
      return `${create_at} روز پیش`;
    } else if (create_at >= 7 && create_at < 30) {
      return `${parseInt(create_at / 7) + 1} هفته پیش`;
    } else if (create_at >= 30 && create_at < 365) {
      return `${parseInt(create_at / 30) + 1} ماه پیش`;
    } else if (create_at >= 365) {
      return `${parseInt(create_at / 365) + 1} سال پیش`;
    }
    return '';
  };